import { render, staticRenderFns } from "./editDialogCggl.vue?vue&type=template&id=822a37c2"
import script from "./editDialogCggl.vue?vue&type=script&lang=ts"
export * from "./editDialogCggl.vue?vue&type=script&lang=ts"
import style0 from "./editDialogCggl.vue?vue&type=style&index=0&id=822a37c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports